module.exports = __webpack_public_path__ + "static/media/bravecto-logo.a9934070.svg";